import { useState } from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  collectionDoc,
  collectionRef,
} from "@/api/collectionRef/collectionOperations";
import { Profile } from "@/models/database/profiles/profile.model";

export const useFindWinner = () => {
  const [data, setData] = useState<any>(null);
  const [user, setUser] = useState<Profile | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const findUser = async (uid: string) => {
    try {
      setLoading(true);

      await collectionDoc.profiles(uid, brand.tenantId).then((doc) => {
        if (doc.exists) {
          setUser(doc.data() as Profile);
        } else {
          setError(new Error("No user document found!"));
        }
      });

      setLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const findWinner = async () => {
    try {
      const ref = collectionRef
        .precisionGame(brand.tenantId, "gamebox-2025-ps5-raffle")
        .where("score", "==", 1337);

      await ref.get().then((querySnapshot) => {
        const winners = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const winner = winners[Math.floor(Math.random() * winners.length)];

        // Check if winner is not null
        if (!winner) {
          setError(new Error("No winner found"));
          return;
        }

        setError(null);

        findUser(winner.uid).then(() => {
          setData({
            winner: winner,
            user: user,
          });
        });
      });

      setLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    data: user,
    loading,
    error,
    findWinner,
  };
};
